import { render, staticRenderFns } from "./agemodel.vue?vue&type=template&id=7d711f5a&scoped=true&"
import script from "./agemodel.vue?vue&type=script&lang=js&"
export * from "./agemodel.vue?vue&type=script&lang=js&"
import style0 from "./agemodel.vue?vue&type=style&index=0&id=7d711f5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d711f5a",
  null
  
)

export default component.exports